/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the HealthResponse interface.
 */
export function instanceOfHealthResponse(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function HealthResponseFromJSON(json) {
    return HealthResponseFromJSONTyped(json, false);
}
export function HealthResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': json['status'],
    };
}
export function HealthResponseToJSON(json) {
    return HealthResponseToJSONTyped(json, false);
}
export function HealthResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': value['status'],
    };
}
